import type {
  PromptResolve,
  SelectOption,
} from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, Select } from '@/components_deprecated'
import { Field, Form } from '@/modules/companies'
import type { EditAbsenceStatusForm } from '@/modules/timesheets/types'
import styled from 'styled-components'
import type { TimesheetsDayReportAbsence } from '../types.graphql'

const ModalStyled = styled(RegularModal)`
  @media screen and (max-width: 768px) {
    overflow-y: visible !important;
  }
`

interface EditAbsenceStatusModalProps {
  absence: Pick<TimesheetsDayReportAbsence, 'id' | 'requestStatus'>
  onSubmit: PromptResolve<EditAbsenceStatusForm | null>
}

export const EditAbsenceStatusModal: React.FC<EditAbsenceStatusModalProps> = ({
  absence,
  onSubmit,
}) => {
  const translations = useTranslate({
    status: 'common.status',
    editAbsenceStatus: 'timesheets.edit-absence-status',
    approved: 'timesheets.absence-approved',
    pending: 'timesheets.absence-pending',
    rejected: 'timesheets.absence-rejected',

    cancel: 'common.cancel',
    submit: 'common.submit',
  })

  const {
    formValues: form,
    updateForm,
    submitHandler: submit,
  } = useForm<EditAbsenceStatusForm>({
    values: {
      requestStatus: absence.requestStatus,
    },
  })

  const requestStatusOptions: SelectOption<
    EditAbsenceStatusForm['requestStatus']
  >[] = [
    { value: 'APPROVED', label: translations.approved },
    { value: 'PENDING', label: translations.pending },
    { value: 'REJECTED', label: translations.rejected },
  ]

  return (
    <ModalStyled
      title={translations.editAbsenceStatus}
      submitText={translations.submit}
      cancelOnClickOutside
      width="400px"
      onSubmit={submit(onSubmit)}
      onCancel={() => onSubmit(null)}
    >
      <Form>
        <Field>
          <label>{translations.status}</label>
          <Select
            value={form.requestStatus}
            options={requestStatusOptions}
            fullWidth
            grayed
            onChange={value => !!value && updateForm({ requestStatus: value })}
          />
        </Field>
      </Form>
    </ModalStyled>
  )
}
